export default __webpack_public_path__ + "static/snap_compare_lager_6m_tag-19dddaae6539bf494c1c8716f8f4792e.webp";